// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-report {
  background-color: #ffffff;
  border: 1px solid black;
  border-radius: 0.3rem;
  overflow-y: auto;
  min-height: 50vh;
  height: 50vh;
  overflow-y: scroll;
}

.cancelButton {
  background: #F9F9F9 0% 0% no-repeat padding-box;
  border: 1px solid #0079DE;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font: normal normal bold 16px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #0079DE;
  opacity: 1;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 220px;
}

.backButton {
  background: #F9F9F9 0% 0% no-repeat padding-box;
  opacity: 1;
  text-align: center;
  font: normal normal bold 16px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #3a3f43;
  opacity: 1;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Step6/Step6.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACF,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;AACF;;AAEE;EACE,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;AACJ","sourcesContent":[".status-report{\n    background-color: #ffffff;\n  border: 1px solid black;\n  border-radius: 0.3rem;\n  overflow-y: auto;\n  min-height: 50vh;\n  height: 50vh;\n  overflow-y: scroll;\n}\n\n.cancelButton{\n  background: #F9F9F9 0% 0% no-repeat padding-box;\n  border: 1px solid #0079DE;\n  border-radius: 4px;\n  opacity: 1;\n  text-align: center;\n  font: normal normal bold 16px/19px Helvetica Neue;\n  letter-spacing: 0px;\n  color: #0079DE;\n  opacity: 1;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  width: 220px;\n  }\n\n  .backButton{\n    background: #F9F9F9 0% 0% no-repeat padding-box;\n    opacity: 1;\n    text-align: center;\n    font: normal normal bold 16px/19px Helvetica Neue;\n    letter-spacing: 0px;\n    color: #3a3f43;\n    opacity: 1;\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    width: 100px;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
